module.exports = __webpack_public_path__ + "static/media/wave-haikei.7cc929b9.svg";